export default {
  "de-DE": {
    "text001": "Heldenliste",
    "text002": "Die Helden deiner Wahl:",
    "text003": "\"Wähle deine Legenden: Runde 4\" findet vom 22.1.2020 bis 29.1.2020 um 03:59 Uhr CET (2:59 Uhr UTC) statt.",
    "day001": "Tag 1",
    "day002": "Tag 2",
    "day003": "Tag 3",
    "day004": "Tag 4",
    "day005": "Tag 5",
    "day006": "Tag 6",
    "day007": "Tag 7",
    "label001": "Gewählt",
    "label002": "Triff deine Wahl",
    "btn001": "Los geht's!",
    "text004": "Wähle und verdiene besondere Hintergrundbilder!",
    "btn002": "Durch 3 Abstimmungen verdient",
    "btn003": "Durch 6 Abstimmungen verdient"
  },
  "en-GB": {
    "text001": "Battle Ballot",
    "text002": "The Heroes you've chosen:",
    "text003": "Choose Your Legends: Round 4 runs from 22/01/2020 to 29/01/2020 at 2:59 a.m. UTC.",
    "day001": "Day 1",
    "day002": "Day 2",
    "day003": "Day 3",
    "day004": "Day 4",
    "day005": "Day 5",
    "day006": "Day 6",
    "day007": "Day 7",
    "label001": "Chosen",
    "label002": "Make your choice",
    "btn001": "Go",
    "text004": "Vote and earn special wallpaper!",
    "btn002": "Earned with three votes",
    "btn003": "Earned with six votes"
  },
  "es-ES": {
    "text001": "Registro",
    "text002": "He apoyado a",
    "text003": "Elige a tus héroes (4) estará activo entre el 22/01/2020 y el 29/01/2020 a las 03:59 CET (02:59 UTC).",
    "day001": "Día 1",
    "day002": "Día 2",
    "day003": "Día 3",
    "day004": "Día 4",
    "day005": "Día 5",
    "day006": "Día 6",
    "day007": "Día 7",
    "label001": "Elegido",
    "label002": "Haz tu elección.",
    "btn001": "¡Elige!",
    "text004": "¡Vota y llévate fondos de pantalla!",
    "btn002": "Se consigue con 3 votos.",
    "btn003": "Se consigue con 6 votos."
  },
  "fr-FR": {
    "text001": "Historique",
    "text002": "Héros pour lesquels vous avez voté :",
    "text003": "Durée de l'événement : du 22/01/2020 au 29/01/2020 à 03:59 CET (02:59 UTC).",
    "day001": "Jour 1",
    "day002": "Jour 2",
    "day003": "Jour 3",
    "day004": "Jour 4",
    "day005": "Jour 5",
    "day006": "Jour 6",
    "day007": "Jour 7",
    "label001": "Votre choix",
    "label002": "Faites votre choix !",
    "btn001": "C'est parti !",
    "text004": "Votez et gagnez un fond d'écran spécial !",
    "btn002": "Obtenu avec trois votes",
    "btn003": "Obtenu avec six votes"
  },
  "it-IT": {
    "text001": "Lista scelte",
    "text002": "Eroi che hai scelto:",
    "text003": "Scegli le tue leggende 4 si terrà dal 22/01/2020 al 29/01/2020 alle 03:59 CET (02:59 UTC).",
    "day001": "Giorno 1",
    "day002": "Giorno 2",
    "day003": "Giorno 3",
    "day004": "Giorno 4",
    "day005": "Giorno 5",
    "day006": "Giorno 6",
    "day007": "Giorno 7",
    "label001": "Scelto",
    "label002": "Fai la tua scelta",
    "btn001": "Scegli",
    "text004": "Vota e ottieni uno sfondo speciale!",
    "btn002": "Ottenuto con 3 voti",
    "btn003": "Ottenuto con 6 voti"
  },
  "ja-JP": {
    "text001": "マイページ",
    "text002": "{{nickname}}が投票した英雄",
    "text003": "投票期間：1/22〜1/29 11:59まで",
    "day001": "Day1",
    "day002": "Day2",
    "day003": "Day3",
    "day004": "Day4",
    "day005": "Day5",
    "day006": "Day6",
    "day007": "Day7",
    "label001": "投票済み",
    "label002": "未投票",
    "btn001": "投票する",
    "text004": "投票してオリジナル壁紙を手に入れよう！",
    "btn002": "3回投票で獲得",
    "btn003": "6回投票で獲得"
  },
  "zh-TW": {
    "text001": "My Page",
    "text002": "{{nickname}}投票的英雄",
    "text003": "投票期間：1/22〜1/29 11:59 (JST)",
    "day001": "Day1",
    "day002": "Day2",
    "day003": "Day3",
    "day004": "Day4",
    "day005": "Day5",
    "day006": "Day6",
    "day007": "Day7",
    "label001": "投票完成",
    "label002": "尚未投票",
    "btn001": "進行投票",
    "text004": "快來投票獲得原創桌布吧！",
    "btn002": "第3次投票後獲得",
    "btn003": "第6次投票後獲得"
  },
  "en-US": {
    "text001": "Battle Ballot",
    "text002": "The Heroes you've chosen:",
    "text003": "Choose Your Legends: Round 4 runs from 1/21/2020 to 1/28/2020 at 6:59 p.m. PT.",
    "day001": "Day 1",
    "day002": "Day 2",
    "day003": "Day 3",
    "day004": "Day 4",
    "day005": "Day 5",
    "day006": "Day 6",
    "day007": "Day 7",
    "label001": "Chosen",
    "label002": "Make your choice",
    "btn001": "Go",
    "text004": "Vote and earn special wallpaper!",
    "btn002": "Earned with three votes",
    "btn003": "Earned with six votes"
  },
  "es-MX": {
    "text001": "Boleta",
    "text002": "Elegí a:",
    "text003": "Elige a tus leyendas (4) estará activo entre el 21/01/2020 y el 28/01/2020 a las 18:59 (horario del Pacífico).",
    "day001": "Día 1",
    "day002": "Día 2",
    "day003": "Día 3",
    "day004": "Día 4",
    "day005": "Día 5",
    "day006": "Día 6",
    "day007": "Día 7",
    "label001": "Elegido",
    "label002": "Haz tu elección.",
    "btn001": "¡Elige!",
    "text004": "¡Vota y llévate fondos de pantalla!",
    "btn002": "Se consigue con 3 votos.",
    "btn003": "Se consigue con 6 votos."
  },
  "fr-CA": {
    "text001": "Historique",
    "text002": "Héros pour lesquels vous avez voté :",
    "text003": "Durée de l'événement : du 21-01-2020 au 28-01-2020 à 18 h 59 HP.",
    "day001": "Jour 1",
    "day002": "Jour 2",
    "day003": "Jour 3",
    "day004": "Jour 4",
    "day005": "Jour 5",
    "day006": "Jour 6",
    "day007": "Jour 7",
    "label001": "Votre choix",
    "label002": "Faites votre choix!",
    "btn001": "C'est parti!",
    "text004": "Votez et gagnez un fond d'écran spécial!",
    "btn002": "Obtenu avec trois votes",
    "btn003": "Obtenu avec six votes"
  },
  "pt-BR": {
    "text001": "Cédula",
    "text002": "Você escolheu os seguintes heróis:",
    "text003": "O evento Escolha suas lendas (4) estará disponível de 21/01/2020 a 28/01/2020 às 18h59 (horário do Pacífico).",
    "day001": "1º dia",
    "day002": "2º dia",
    "day003": "3º dia",
    "day004": "4º dia",
    "day005": "5º dia",
    "day006": "6º dia",
    "day007": "7º dia",
    "label001": "Escolhido",
    "label002": "Faça a sua escolha",
    "btn001": "Escolha!",
    "text004": "Vote e receba papéis de parede especiais!",
    "btn002": "Consiga com três votos",
    "btn003": "Consiga com seis votos"
  }
}